import { useEffect, useState } from 'react';
import { useMatches } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import { useBreakpoints } from '../../hooks/useBreakpoints';
import { pageState, sidenavIsPinnedState } from '../../storage/app';

export function AppProvider() {
  const { isSmall } = useBreakpoints();
  const setSidenavIsPinned = useSetRecoilState(sidenavIsPinnedState);
  const setPage = useSetRecoilState(pageState);
  const [isInitialLoad, setInitialLoad] = useState(true);
  const matches = useMatches();

  useEffect(() => {
    if (isInitialLoad) {
      setInitialLoad(false);
      return
    }
    if (isSmall) {
      setSidenavIsPinned(false);
    }
  }, [isSmall]);

  useEffect(() => {
    if (matches.length) {
      setPage(matches[matches.length - 1].id);
    } else {
      setPage('');
    }
  }, [matches, setPage]);

  return null;
}
